import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";
import { compose, lifecycle, withHandlers, withState } from "recompose";
import {
  Menu,
  Sidebar as SemanticSidebar,
  Responsive
} from "semantic-ui-react";
import styled from "styled-components";
import { UserData } from "./components";
import SidasApiLogo from "../sidas-api-logo";
import { signOut } from "./../../redux/modules/authentication";
import { hideSidebar } from "./../../redux/modules/navigationSidebar";

const Sidebar = ({
  isDesktop,
  handleHideSidebar,
  onSignOut,
  user,
  visible
}) => (
  <SidebarContainer
    animation="overlay"
    as={Menu}
    onHide={handleHideSidebar}
    vertical
    visible={visible || isDesktop}
  >
    <LogoMenuItem>
      <SidasApiLogo />
    </LogoMenuItem>
    {user && (
      <UserDataMenuItem>
        <UserData onSignOut={onSignOut} user={user} />
      </UserDataMenuItem>
    )}
    <Menu.Item header>Nawigacja</Menu.Item>
    <Menu.Item
      as={NavLink}
      content="Konteksty"
      icon="building"
      to="/konteksty"
    />
    <Menu.Item as={NavLink} content="Logi" icon="clipboard list" to="/logi" />
    <Menu.Item
      as={NavLink}
      content="Historia statusow spraw"
      icon="history"
      to="/historia-statusow-spraw"
    />
  </SidebarContainer>
);

Sidebar.propTypes = {
  isDesktop: PropTypes.bool,
  handleHideSidebar: PropTypes.func.isRequired,
  onSignOut: PropTypes.func.isRequired,
  user: PropTypes.object,
  visible: PropTypes.bool
};

Sidebar.defultProps = {
  user: {}
};

const SidebarContainer = styled(SemanticSidebar)`
  &&& {
    width: 300px;
    z-index: 1000;
  }
`;

const LogoMenuItem = styled(Menu.Item)`
  &&&& {
    align-items: center;
    display: flex;
    height: 65px;
    justify-content: center;
  }
`;

const UserDataMenuItem = styled(Menu.Item)`
  &&&& {
    padding: 0.25rem 0;
  }
`;

const mapStateToProps = ({
  authentication: { accessToken, user },
  navigationSidebar: { visible }
}) => ({
  isAuthenticated: accessToken !== null,
  user,
  visible
});

const mapDispatchToProps = dispatch => ({
  onHideSidebar: () => dispatch(hideSidebar()),
  onSignOut: () => {
    dispatch(signOut());
    dispatch(hideSidebar());
  }
});

const enhance = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withState("isDesktop", "setIsDesktop", false),
  withHandlers({
    handleHideSidebar: ({ isDesktop, onHideSidebar }) => () => {
      if (!isDesktop) {
        onHideSidebar();
      }
    },
    updateIsDesktop: ({ setIsDesktop }) => () =>
      setIsDesktop(window.innerWidth >= Responsive.onlyComputer.minWidth)
  }),
  lifecycle({
    componentDidMount() {
      this.props.updateIsDesktop();
      window.addEventListener("resize", this.props.updateIsDesktop);
    },
    componentWillUnmount() {
      window.removeEventListener("resize", this.props.updateIsDesktop);
    }
  })
);

export default enhance(Sidebar);



// WEBPACK FOOTER //
// ./src/components/sidebar/Sidebar.js